import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
	AUTH_TOKEN,
	SIGNIN,
	SIGNOUT,
	SIGNUP,
	SIGNIN_WITH_GOOGLE,
	SIGNIN_WITH_FACEBOOK,
	GET_USER_ME
} from '../constants/Auth';
import {
	showAuthMessage,
	authenticated,
	signUpSuccess,
	signInWithGoogleAuthenticated,
	signInWithFacebookAuthenticated,
	getUserMeSuccess,
	signInSuccess,
	signOutSuccess
} from "../actions/Auth";

import FirebaseService from 'services/FirebaseService'
import JwtAuthService from "../../services/JwtAuthService";
import UserService from '../../services/api/user';


export function* signInWithFBEmail() {
  // yield takeEvery(SIGNIN, function* ({payload}) {
	// 	const {email, password} = payload;
	// 	try {
	// 		const user = yield call(FirebaseService.signInEmailRequest, email, password);
	// 		if (user.message) {
	// 			yield put(showAuthMessage(user.message));
	// 		} else {
	// 			localStorage.setItem(AUTH_TOKEN, user.user.uid);
	// 			yield put(authenticated(user.user.uid));
	// 		}
	// 	} catch (err) {
	// 		yield put(showAuthMessage(err));
	// 	}
	// });
}


export function* loginUser() {

	yield takeEvery(SIGNIN, function* ({payload}) {
		try {
			const response = yield call(UserService.login, payload);
			if (response.message) {
				yield put(showAuthMessage(response.message));
			} else {
				localStorage.setItem(AUTH_TOKEN, response.token);
				const user = yield call(UserService.getUserMe);
				if (user.message) {
					yield put(showAuthMessage(user.message));
				} else {
					user.token = response.token;
					yield put(signInSuccess(user));
				}
			}
		} catch (error) {
			//console.log(error.response.data.error)
			yield put(showAuthMessage('Credenciales incorrectas'));
		}
	})
}

export function* getUserMe() {
	yield takeEvery(GET_USER_ME, function* () {
		try {
			const user = yield call(UserService.getUserMe);
			if (user.message) {
				yield put(showAuthMessage(user.message));
			} else {
				//console.log('respuesta del servi', user)
				yield put(getUserMeSuccess(user));
			}
		} catch (error) {
			yield put(showAuthMessage(error));
		}
	});
}

export function* signOut() {
	yield takeEvery(SIGNOUT, function* () {
		try {
			// ToDo Revoke token with api.
			// const signOutUser = yield call(FirebaseService.signOutRequest);
			// if (signOutUser === undefined) {
			localStorage.removeItem(AUTH_TOKEN);
			yield put(signOutSuccess(undefined));
			// yield put(signOutSuccess(signOutUser));
			// } else {
			// 	yield put(showAuthMessage(signOutUser.message));
			// }
		} catch (err) {
			yield put(showAuthMessage(err));
		}
	});
}

export function* signUpWithFBEmail() {
  yield takeEvery(SIGNUP, function* ({payload}) {
		const {email, password} = payload;
		try {
			const user = yield call(FirebaseService.signUpEmailRequest, email, password);
			if (user.message) {
				yield put(showAuthMessage(user.message));
			} else {
				localStorage.setItem(AUTH_TOKEN, user.user.uid);
				yield put(signUpSuccess(user.user.uid));
			}
		} catch (error) {
			yield put(showAuthMessage(error));
		}
	}
	);
}

export function* signInWithFBGoogle() {
  yield takeEvery(SIGNIN_WITH_GOOGLE, function* () {
		try {
			const user = yield call(FirebaseService.signInGoogleRequest);
			if (user.message) {
				yield put(showAuthMessage(user.message));
			} else {
				localStorage.setItem(AUTH_TOKEN, user.user.uid);
				yield put(signInWithGoogleAuthenticated(user.user.uid));
			}
		} catch (error) {
			yield put(showAuthMessage(error));
		}
	});
}

export function* signInWithFacebook() {
  yield takeEvery(SIGNIN_WITH_FACEBOOK, function* () {
		try {
			const user = yield call(FirebaseService.signInFacebookRequest);
			if (user.message) {
				yield put(showAuthMessage(user.message));
			} else {
				localStorage.setItem(AUTH_TOKEN, user.user.uid);
				yield put(signInWithFacebookAuthenticated(user.user.uid));
			}
		} catch (error) {
			yield put(showAuthMessage(error));
		}
	});
}

export default function* rootSaga() {
  yield all([
		fork(signInWithFBEmail),
		fork(signOut),
		fork(signUpWithFBEmail),
		fork(signInWithFBGoogle),
		fork(signInWithFacebook),
	  	fork(loginUser),
	  	fork(getUserMe),
  ]);
}
